import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";
import { TemplateParameter } from "../facades/TemplateParameter";
import { RawTemplatePararameter } from "../typings/RawTemplateParameter";

type GetTemplateParametersResponse = {
  data: RawTemplatePararameter[];
};

export const useGetTemplateParameters = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/templates/parameters",
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: true,
  transformResponse: (response: GetTemplateParametersResponse) =>
    response.data.map((parameter) => new TemplateParameter(parameter)),
});
